import { EditorMode } from '~/common/types';

/**
 * The editor mode a toolbar button click lands on. Clicking the tool that is already active puts it
 * back down, matching the "Exit draw mode" button, so the toolbar can both arm and disarm a tool.
 *
 * @param opensPicker buttons whose click opens a picker (Image, Stamp) — a second click reopens the
 * picker rather than exiting draw mode.
 */
export function toolbarClickMode(editorMode: EditorMode, mode: EditorMode, opensPicker = false): EditorMode {
  return editorMode === mode && !opensPicker ? EditorMode.None : mode;
}
